// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "80c7223-dirty",
    "hash": "80c7223",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "80c7223-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
